import React, { useState, useEffect } from 'react';

export default function updateTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
}